/** @jsxImportSource theme-ui */
import { format } from 'date-fns';
import { useGetVossSubscriptionLicensesQuery } from '@/store/apiService';
import DataTable from '@/components/DataTable';

const formatDate = (value?: string) => (value ? format(new Date(value), 'd MMM yyyy, p') : '');

const columns = [
    {
        Header: 'Status',
        id: 'status',
        accessor: 'status',
    },
    {
        Header: 'Product',
        id: 'productName',
        accessor: 'product.name',
    },
    {
        Header: 'Article number',
        id: 'articleNumber',
        accessor: 'product.articleNumber',
    },
    {
        Header: 'Quantity',
        id: 'currentQuantity',
        accessor: 'currentQuantity',
    },
    {
        Header: 'Max quantity',
        id: 'maxQuantity',
        accessor: 'maxQuantity',
    },
    {
        Header: 'Local license id (external id)',
        id: 'externalId',
        accessor: 'externalId',
    },
    {
        Header: 'Id',
        id: 'id',
        accessor: 'id',
    },
    {
        Header: 'Created',
        id: 'created',
        accessor: 'created',
        Cell: ({ cell }) => formatDate(cell.value),
    },
    {
        Header: 'Termination',
        id: 'termination',
        accessor: 'termination',
        Cell: ({ cell }) =>
            cell.value
                ? `${cell.value.type ?? ''} ${formatDate(cell.value.scheduledDate)}`.trim()
                : '',
    },
];

const SubscriptionLicenses: React.FC<{ id: string }> = ({ id }) => {
    const subscriptionLicenses = useGetVossSubscriptionLicensesQuery({ id });

    return (
        <DataTable
            data={subscriptionLicenses.data}
            columns={columns}
            isLoading={subscriptionLicenses.isLoading}
            isFetching={subscriptionLicenses.isFetching}
            sortBy={[{ id: 'status', asc: true }]}
        />
    );
};

export default SubscriptionLicenses;
